import { makeStyles } from "@material-ui/core/styles";
import emptyStateImg from "../../assets/images/comparison-graph.svg";

const useStyles = makeStyles((theme) => ({
  toastMsg: {
    "& .MuiAlert-root": {
      minHeight: 100,
      minWidth: 400,
      maxWidth: 500,
      display: "flex",
      alignItems: "center",
      boxShadow: "0px 0px 27px #5A614829",
      position: "relative",
      border: "solid 1px",
      borderRadius: 10,
      padding: "0 0 0 15px",
      [theme.breakpoints.down("xs")]: {
        minWidth: "100%",
        maxWidth: "100%",
        minHeight: 70,
      },
      "& svg": {
        fontSize: 50,
        opacity: 1,
        marginRight: 10,
        marginLeft: 10,
        [theme.breakpoints.down("xs")]: {
          fontSize: 32,
          margin: 0,
        },
      },
      "& .MuiAlert-message": {
        marginRight: 16,
      },
    },
    "& .MuiAlert-action": {
      minHeight: 100,
      marginRight: 0,
      padding: 10,
      borderRadius: "0 10px 10px 0",
      [theme.breakpoints.down("xs")]: {
        minHeight: 70,
      },
      "& button": {
        cursor: "pointer",
        "& svg": {
          fontSize: 20,
          background: "none",
          margin: 0,
        },
      },
    },
    "& .MuiAlert-standardSuccess": {
      background: "#F0FFF1",
      borderColor: "#85D6B0",
      "& .MuiAlert-message": {
        color: "#02A561",
      },
      "& .MuiAlert-action": {
        background: "#AFEFB3",
        "& button": {
          color: "#57C698",
        },
      },
    },
    "& .MuiAlert-standardError": {
      background: "#FFF3F2",
      borderColor: "#FFADAD",
      "& .MuiAlert-message": {
        color: "#F36F6F",
      },
      "& .MuiAlert-action": {
        background: "#FFD9D9",
        "& button": {
          color: "#CC653691",
        },
      },
    },
    "& .MuiAlert-standardWarning": {
      background: "#FFF3F2",
      borderColor: "#FFADAD",
      "& .MuiAlert-message": {
        color: "#F36F6F",
      },
      "& .MuiAlert-action": {
        background: "#FFD9D9",
        "& button": {
          color: "#CC653691",
        },
      },
    },
  },
  msgTitle: {
    fontSize: 20,
    margin: 0,
    fontWeight: 400,
    maxWidth: 320,
  },
  noDataImg: {
    minHeight: 300,
  },
  emptyState: {
    background: `url(${emptyStateImg}) no-repeat`,
    backgroundPosition: "bottom",
    backgroundSize: "contain",
  },
  emptyStateMsg: {
    background: "rgb(255 255 255 / 85%)",
  },
  errorMsg: {
    position: "absolute",
    left: 200,
    top: 12,
    zIndex: 1,
    [theme.breakpoints.down("xs")]: {
      left: 16,
      top: -35,
    },
  },
  compareError: {
    position: "absolute",
    top: -22,
    left: 0,
    width: "100%",
    "& > div": {
      position: "unset",
    },
  },
  displayError: {
    marginRight: 10,
    // "& > div": {
    //   position: "unset"
    // }
  },
  // deactivated user
  deactivatedUser: {
    filter: "grayscale(100%)",
  },
  deactivatedUserIcon: {
    color: "#919191",
    width: 15,
    height: 15,
    position: "absolute",
    bottom: 0,
    background: "#fff",
    borderRadius: "50%",
    padding: 1,
    left: -4,
  },
  toastWidget: {
    "& .confetti-wrapper": {
      width: "auto",
      height: "auto",
      left: "auto",
      right: -100,
      top: -300,
      "& img": {
        width: 800,
        height: "auto",
      },
    },
    "& .MuiSnackbar-root": {
      zIndex: "999999 !important",
    },
  },
  userLink: {
    textDecoration: "none",
  },
}));

export default useStyles;
